'use strict';

exports.__esModule = true;
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var validateClass = exports.validateClass = function validateClass(clazz, decorator) {
  if (typeof clazz !== 'function') {
    throw new Error('@' + decorator + ' decorator can only be applied to class not: ' + (typeof clazz === 'undefined' ? 'undefined' : _typeof(clazz)));
  }
};
var validateFunction = exports.validateFunction = function validateFunction(func, decorator) {
  if (typeof func !== 'function') {
    throw new Error('@' + decorator + ' decorator can only be applied to methods not: ' + (typeof func === 'undefined' ? 'undefined' : _typeof(func)));
  }
};
var validateClassAndFunction = exports.validateClassAndFunction = function validateClassAndFunction(func, decorator) {
  if (typeof func !== 'function') {
    throw new Error('@' + decorator + ' decorator can only be applied to class and methods not: ' + (typeof func === 'undefined' ? 'undefined' : _typeof(func)));
  }
};